export const isNotNullish = (p) => p !== null && p !== undefined;
